import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Location } from "@angular/common";

//INCLUINDO LIB PARA FORM REATIVOS
import { FormGroup, FormControl, FormBuilder, Validators } from "@angular/forms";

import { FormUtils } from "../../shared/form.utils";
import { Task } from "../shared/task.model";
import { TaskService } from "../shared/task.service";

@Component({
    selector: 'task-detail',
    templateUrl: './task-detail.component.html'
})

export class TaskDetailComponent implements OnInit, AfterViewInit{

    //CRIA UMA VARIÁVEL QUE RECEBE A TAREFA SELECIONADA PARA DETALHE
    public task: Task;
    public taskDoneOptions: Array<any>;
    public formUtils: FormUtils;

    //VAR PARA O FORM REACTIVE
    public form: FormGroup;

    constructor(
        private taskService: TaskService,
        private route: ActivatedRoute,
        private location: Location,
        private formBuilder: FormBuilder
    ) {
        //this.task = new Task(1, "Atribuindo tarefa manual");

        //INICIA O ARRAY COM ESSAS OPÇÕES
        this.taskDoneOptions =[
            { value: false, text: "Pendente"},
            { value: true, text: "Feito"}
        ];

        this.form = this.formBuilder.group({
            title: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]],
            deadline: [null, Validators.required],
            done: [null, Validators.required],
            description: [null],
        });

        this.formUtils = new FormUtils(this.form);
    }

    /**
     * ngOnInit
     */
    public ngOnInit() {

        //CRIA ESSA NOVA TAREFA PARA NÃO DAR ERRO DE NÃO HAVER NENHUMA TAREFA.
        this.task = new Task(null, null);

        this.route.params
            //PEGA A ÚLTIMA TAREFA ESCOLHIDA E RETORNA PARA O SUBSCRIBE UMA TASK
            .switchMap((params: Params) => this.taskService.getById(+params['id']))
            //O SUBSCRIBE SETA A TAREFA RECEBIDA DO SWITCHMAP NA VARIÁVEL DO CONSTRUTOR
            .subscribe(
                task => this.setTask(task),
                error => alert("Erro task-detail!")
            );
    }

    /**
     * setTask
     * PARA SETAR OS VALORES VINDOS DO FORMLÁRIO
     */
    public setTask(task: Task): void {
        this.task = task;

        this.form.patchValue(task);
    }

    /**
     * ngAfterViewInit
     * SUBSTITUI O DOCUMENT.READY DO JS
     * MÉTODO RESPONSÁVEL DE FAZER ALGO APÓS O TEMPLATE FOR CARREGADO
     */
    public ngAfterViewInit() {

        //$("#deadline").datetimepicker({
            //'sideBySide': true,
            //'locale': 'pt-br'
       // }).on('dp.change', function() {this.task.deadline = $("#deadline").val()});
    }

    /**
     * goBack
     */
    public goBack() {
        this.location.back();
    }

    /**
     * updateTask
     */
    public updateTask() {

        this.task.title       = this.form.get('title').value;
        this.task.deadline    = this.form.get('deadline').value;
        this.task.done        = this.form.get('done').value;
        this.task.description = this.form.get('description').value;

        if(!this.task.title){
            alert("Tarefa deve ter um título!");
        }else{
            this.taskService.update(this.task)
                .subscribe(
                    (task) => {this.task = task;
                        alert("Tarefa atualizada com sucesso!")},
                    () => alert("Ocorreu um erro no serviço, tente mais tarde.")
                );
        }
    }

}


// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/tasks/task-detail/task-detail.component.ts